var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
    ("" + _vm.cssPrefix),
    'sw-flexbox',
    'sw-flexbox--center-items',
    (_vm.cssPrefix + "--" + (_vm.navParam.theme)) ]},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }